import React from 'react';
export default ({ className }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 100 125"
    xmlSpace="preserve"
    className={className}
  >
    <g>
      <path d="M18.6,86.9h38.8c3.1,0,5.6-2.5,5.6-5.6V65.6c0-3.1-2.5-5.6-5.6-5.6H41c-5.5,0-10-4.5-10-10c0-5.5,4.5-10,10-10h16.4   c3.1,0,5.6-2.5,5.6-5.6V18.7c0-3.1-2.5-5.6-5.6-5.6H18.6c-3.1,0-5.6,2.5-5.6,5.6v62.6C13,84.4,15.5,86.9,18.6,86.9z" />
      <path d="M70,34.2V45H41c-2.8,0-5,2.2-5,5s2.2,5,5,5h29v10.5c0,2.3,2.9,3.5,4.5,1.8l15.1-16.2c0.9-1,0.9-2.6-0.1-3.6L74.4,32.4   C72.8,30.8,70,31.9,70,34.2z" />
    </g>
  </svg>
);
